<template>
  <div style="height: 100%;     overflow-y: auto;">
    <Topbar v-if="this.$store.state.topbar_actions_visible" @action="getAction"></Topbar>

    <v-layout row xs12 sm12 md12 style="height:100%">
      <v-flex xs3 sm3 md3 id="filters">
        <div id="search">
          <v-text-field hide-details prepend-icon="search" single-line v-model="search"></v-text-field>

          <v-btn icon>
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs9 sm9 md9 id="transactions">
        <div id="info">{{ 'finances.import.info' | i18n }}</div>
        

        <div v-for="transaction in transactions" :id="transaction.id" >
          <div
            v-if="!transaction.duplicate"
            class="transaction"
            :class="{not_added: !transaction.added}"
          >
            <div class="date">
              <span>{{ transaction.date }}</span>
              <span class="affair">{{ transaction.affair }}</span>
            </div>
            <div class="info">
              <span class="import">{{ transaction.import }}{{coin}}</span>
              <input
                class="switch"
                type="checkbox"
                v-model="transaction.added"
                @click="changeState(transaction.id)"
              />
            </div>
          </div>
        </div>
        <div v-if="duplicated" class="alert" style="margin-top: 20px; margin-bottom: 10px;">
          <p>{{ 'finances.import.duplicated.label' | i18n }}</p>
          <span>{{ 'finances.import.duplicated.text' | i18n }}</span>
        </div>
        <div v-for="transaction in transactions" :id="transaction.id" class="duplicated">
          <div v-if="transaction.duplicate" class="transaction duplicate">
            <div class="date">
              <span>{{ transaction.date }}</span>
              <span class="affair">{{ transaction.affair }}</span>
            </div>
            <div class="info">
              <span class="import">{{ transaction.import }}{{coin}}</span>
              <input
                class="switch"
                type="checkbox"
                v-model="transaction.added"
                @click="changeState(transaction.id)"
              />
            </div>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import i18n from "@/i18n";
import { Api } from "@/core/api.js";
import Topbar from "@/components/ui/Topbar";
const api = new Api();

export default {
  name: "CardFinance",
  components: { Topbar },
  props: { page: String, action: String },
  data() {
    return {
      length: 0,
      transactions: {},
      search: "",
      duplicated: false
    };
  },
  computed: {
    coin(){
        let event = this.$store.getters[ 'events/getCurrentEvent' ]()
        return event.type_id == 15 ? '$' : '€'
    }
  },
  created() {
    this.$store.commit("setTopbarActionsVisible", true);
    this.$store.commit("setMenuVisible", true);
    var id = this.$route.params.id;
    this.on_init();
    this.length = Object.keys(this.transactions).length;
    if (!this.length) {
      this.$router.push({ name: "event_finances", params: {} });
    }
    this.$overlay.hide();
  },
  methods: {
    getAction(params) {
      if (params.action == "save") this.save();
    },
    on_init() {
      var oTransactions = {
        ...this.$store.getters["finances/getImportationList"]()
      };
      for (const key in oTransactions) {
        if (
          oTransactions[key].duplicate == undefined ||
          oTransactions[key].duplicate == false
        ) {
          oTransactions[key].added = true;
        } else {
          this.duplicated = true;
          oTransactions[key].added = false;
        }
      }
      this.transactions = { ...oTransactions };
    },
    changeState(id) {
      var cTransactions = { ...this.transactions };
      cTransactions[id].added = !cTransactions[id].added;
      this.transactions = cTransactions;
    },
    save() {
      this.$overlay.show();
      var self = this;
      var payload = {};
      for (const key in this.transactions) {
        if (this.transactions[key].added) {
          payload[key] = this.transactions[key];
        }
      }
      var cTransactions = JSON.stringify({ ...payload });

      if (!Object.keys(cTransactions).length) {
        self.$router.push({ name: "event_finances", params: {} });
      }
      var event = this.$store.getters.isEventSelected
      ? this.$store.getters["events/getCurrentEvent"]()
      : false;
      this.$store
        .dispatch("finances/confirmTransactions", {
          transactions: cTransactions,
          event_id: event.id
        })
        .then(data => {
          self.$router.push({ name: "event_finances", params: {} });
        });
    }
  },
  watch: {
    search: {
      handler: value => {
        var input = value;
        var filter = input.toUpperCase();
        var div = document.getElementById("transactions");
        var divs = div.getElementsByTagName("div");
        for (var i = 0; i < divs.length; i++) {
          var p = divs[i];
          var txtValue = p.textContent || p.innerText;
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
            divs[i].style.display = "";
          } else {
            divs[i].style.display = "none";
          }
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
#btn_save {
  width: 50px !important;
  height: 50px !important;
  display: flex !important;
  position: fixed !important;
  right: 25px !important;
  bottom: 25px !important;
  justify-content: center;
  i {
    text-align: center;
  }
}

#transactions {
  overflow-y: scroll;
  .alert {
    width: 90%;
    margin: 10px auto;
    p {
      text-transform: uppercase;
      color: #d80000;
      font-weight: bold;
      font-size: 11px;
      padding: 0px !important;
    }
    span {
      color: #777;
      font-weight: bold;
      font-size: 11px;
    }
  }
}

.summaryOption {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  margin-bottom: 5px;
  div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: calc(100% - 20px);
    span {
      display: inline-block;
      max-width: calc(100% - 75px);
      @include text-ellipsis();
    }
    p {
      width: 75px;
      text-align: right;
    }
  }
  > span {
    width: 20px;
  }
}

.transaction {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  max-width: 90%;
  margin: 5px auto;
  border-bottom: 1px solid #eee;
  padding: 5px 5px;

  img {
    height: 20px;
    margin-left: 5px;
  }
  span:first-of-type {
    display: flex;
    justify-content: space-between;
  }

  .info {
    display: flex;
    width: 30%;
    justify-content: flex-end;
    .import {
      font-weight: bold;
      margin-right: 10px;
      color: #777;
    }
  }
  .date {
    display: flex;
    color: #999;
    span {
      margin-right: 10px;
    }
    .affair {
      color: #777;
      font-weight: bold;
      display: inline-block;
      max-width: 500px;
      @include text-ellipsis();
    }
  }
}
h1 {
  color: #721c24;
  max-width: 80%;
  margin: 20px auto;
}

.duplicate {
  margin: 0px auto !important;
  background-color: #eee;
}

.not_added {
  span {
    color: #aaa !important;
    font-weight: 400 !important;
  }
}

.addBtn {
  cursor: pointer;
}
.closeBtn {
  &:after {
    cursor: pointer;
    content: "\2A2F";
  }
}

#filters {
  border-right: 1px solid;
  padding: 10px;
  margin-top: 10px;
}
.switch {
  $switch-width: 35px;
  $switch-height: 20px;
  $switch-border: 1px;
  $switch-ball-aux: $switch-height - 10px;
  $switch-ball: $switch-ball-aux + 6px;
  $switch-color: #6f83c1;
  display: inline-block;
  position: relative;
  -webkit-appearance: none;
  outline: none;
  max-width: $switch-width;
  width: $switch-width;
  max-height: $switch-height;
  height: $switch-height;
  background-color: #fff;
  border: #{$switch-border} solid #d9dadc;
  border-radius: $switch-width;
  box-shadow: inset -#{$switch-ball-aux} 0 0 0 #fff;
  &:after {
    content: "";
    position: absolute;
    top: $switch-border;
    left: $switch-border;
    background: transparent;
    width: $switch-ball;
    height: $switch-ball;
    border-radius: 50%;
    box-shadow: #{$switch-border * 2} #{$switch-border} 3px rgba(0, 0, 0, 0.2);
  }
  &:checked {
    box-shadow: inset #{$switch-width - $switch-height} 0 0 0 $switch-color;
    border-color: $switch-color;
  }
  &:checked:after {
    left: $switch-ball;
    box-shadow: -#{$switch-border * 2} #{$switch-border} 3px #172654;
  }
}

#info {
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  width: 80%;
  margin: 10px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  font-weight: bold;
  color: black;
  margin-bottom: 20px;
}
</style>
